import { Button, Card, Spinner } from 'flowbite-react'
import React, { useEffect, useState } from 'react'
import CustomSelectInput from '../../../components/CustomSelectInput/CustomSelectInput'
import CustomInput from '../../../components/CustomInputs/CustomInput'
import client from '../../../api/client'
import showToast from '../../../components/CustomToast/toastHelper'
import CustomModal from '../../../components/Modal/CustomModal'
import PaymentSummaryModal from '../PaymentSummaryModal/PaymentSummaryModal'
import ValidatePaymentModal from '../ValidatePaymentModal/ValidatePaymentModal'
import { AirtimePurchaseProps } from '../AirtimePurchase/AirtimePurchase'
import logo from '../../../assets/Ideos.png'

const CableTv = ({ hasPin, triggerPinSetup }: AirtimePurchaseProps) => {
    const [providers, setProviders] = useState<any>([])
    const [packages, setPackages] = useState<any>([])
    const [selectedProvider, setSelectedProvider] = useState<number | null>(null);
    const [activeProvider, setActiveProvider] = useState<string>('')
    const [selectedPackage, setSelectedPackage] = useState<any>([])
    const [smartcardNumber, setSmartcardNumber] = useState<string>('');
    const [amount, setAmount] = useState<number>(0)
    const [loading, setLoading] = useState<boolean>(false)
    const [resolving, setResolving] = useState<boolean>(false)
    const [resolved, setResolved] = useState<boolean>(false)
    const [accountDetails, setAccountDetails] = useState<any>()
    const [categoryId, setCategoryId] = useState<number>(0)
    const [allGood, setAllGood] = useState<boolean>(false)
    const [transactionId, setTransactionId] = useState<any>(1)
    const [openValidationModal, setOpenValidationModal] = useState<boolean>(false)
    const [payload, setPayload] = useState<any>(null)

    const handleClick = () => {
        const canProceed = triggerPinSetup();

        if (canProceed) {
            setOpenValidationModal(true)
        } else {
            console.log("PIN setup required!");
        }
    };

    const validateInputs = () => {
        if (selectedProvider == null || smartcardNumber == '' || amount == 0 || selectedPackage == null || accountDetails == null) {
            setAllGood(false)
        }
        else {
            setAllGood(true)
        }
    }


    const getProviders = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/bills-payment/cable/providers/get');

            setProviders(response.data.data);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };


    const getPackages = async (providerId: number) => {
        try {
            const response = await client.get(`/subsidiary/dashboard/bills-payment/biller/${providerId}/packages`);

            setPackages(response.data.data);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };

    const handleProviderChange = (providerId: any) => {
        const activeProvider = providers.find((x: any) => x.id == providerId)

        setSelectedProvider(providerId);
        setActiveProvider(activeProvider.slug)
        setCategoryId(activeProvider.billerCategoryId)
        setPackages([]);
        getPackages(providerId);
    };

    const handlePackageSelection = (packageId: any) => {
        const selectedPackage = packages.find((x: any) => x.id == packageId)
        setSelectedPackage(selectedPackage.slug)
        setAmount(selectedPackage?.amount)
    }


    const resolveAccount = async () => {
        setResolving(true)
        const payload = {
            customerId: smartcardNumber,
            billerSlug: activeProvider,
            productName: selectedPackage
        }


        try {
            const response = await client.post(`/subsidiary/dashboard/bills-payment/customer-lookup`, payload);

            setAccountDetails(response.data.data)
            setResolved(true)
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
        finally {
            setResolving(false)
        }
    }

    const constructPayload = () => {
        const payload = {
            customerId: smartcardNumber,
            billerSlug: activeProvider,
            amount: amount,
            productName: selectedPackage,
            requiresCustomerLookup: true,
            billType: 'CableTV',
            billCategoryId: categoryId
        }
        setPayload(payload)
    }

    // const initiatePurchase = async () => {

    //     setLoading(true)
    //     const payload = {
    //         customerId: smartcardNumber,
    //         billerSlug: activeProvider,
    //         amount: amount,
    //         productName: selectedPackage,
    //         requiresCustomerLookup: true,
    //         billType: 'CableTV',
    //         billCategoryId: categoryId
    //     }
    //     console.log(payload);

    //     try {
    //         const response = await client.post(`/subsidiary/dashboard/bills-payment/process-payment`, payload);
    //         console.log(response.data);
    //         showToast(response.data.message, "success")
    //         // setProviders([])
    //         // setAmount(0)
    //         setPackages([])
    //         setTransactionId(response.data.data.id)
    //         setOpenSummaryModal(true)
    //     } catch (err: any) {
    //         if (err?.response?.data?.message === 'Please login again') {
    //             sessionStorage.clear();
    //             window.location.href = '/';
    //         } else {
    //             const message = err?.response?.data?.message;
    //             console.error('error getting data', err);
    //             showToast(message, "error");
    //         }
    //     }
    //     finally {
    //         setLoading(false)
    //     }
    // };

    useEffect(() => {
        const fetchData = async () => {
            await getProviders()
        }
        fetchData()
    }, [])

    useEffect(() => {
        if (smartcardNumber.length >= 10 && activeProvider && selectedPackage && activeProvider.toLowerCase() !== "showmax") {
            resolveAccount()
        }
        else {
            setResolving(false)
            setResolved(false)
        }
    }, [activeProvider, selectedPackage, smartcardNumber])

    useEffect(() => {
        validateInputs()
        constructPayload()
    }, [selectedProvider, amount, smartcardNumber, selectedPackage, accountDetails])

    return (
        <div className='grid grid-cols-1 md:grid-cols-3'>
            <div>
                <p className='text-xl font-semibold'>Cable TV Purchase</p>
                <p className='text-xs'>Enter your details to pay for your cable TV</p>
            </div>
            <div className='md:col-span-2 mr-8'>
                <Card className='shadow-none'>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                        <CustomSelectInput label='Service Provider' items={providers} displayKey='name' valueKey='id' onChange={(providerId: any) => handleProviderChange(providerId)} />
                        <CustomSelectInput label='Select Package' items={packages} displayKey='name' valueKey='id' onChange={(packageId: any) => handlePackageSelection(packageId)} />
                        <div>
                            <CustomInput label='Smartcard Number' name='smartcardNumber' value={smartcardNumber} onChange={(e: any) => setSmartcardNumber(e.target.value)} />
                            {resolving ? (
                                <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/70">
                                    <img src={logo} alt="Loading..." className="w-16 animate-spin" />
                                </div>
                            ) : null}
                            {resolved && <span className='text-xs text-green-700'>{accountDetails?.customer?.customerName ?? ""}</span>}
                        </div>
                        <CustomInput label='Amount' type='number' name='amount' value={amount} readonly />
                        {/* <CustomInput label='Phone Number' name='phoneNumber' value={} onChange={(e: any) => setSmartcardNumber(e.target.value)}/> */}
                    </div>
                    <div className='flex justify-end '>
                        <Button className='w-full md:w-2/6 rounded-sm bg-custom-button-green text-black hover:text-white' disabled={allGood == false} onClick={() => handleClick()}>{loading ? <Spinner size='sm' /> : 'Pay for Cable'}</Button>
                    </div>
                </Card>
            </div>
            <CustomModal show={openValidationModal} icon='' dismissible onClose={() => setOpenValidationModal(false)} size='md'>
                <ValidatePaymentModal payload={payload} closeVerificationModal={() => setOpenValidationModal(false)} />
            </CustomModal>
        </div>
    )
}

export default CableTv
